import { green, indigo, orange } from 'utils/theme/colors';
import { background, red } from 'utils/theme/colorsDark';

const styles = (theme) => {
    console.log('theme: ', theme);

    return {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            // background: '#fff',
        },
        appBarShift: {
            [theme.breakpoints.up('sm')]: {
                width: `calc(100% - ${theme.width.drawerRight}px)`,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginRight: theme.width.drawerRight,
            },
        },
        content: {
            flexGrow: 1,
            background: background.default,

            // background: '#fff',
            // padding: theme.spacing(0, 5, 5),
            // [theme.breakpoints.down('md')]: {
            //     // paddingBottom: spacing(4),
            //     // padding: spacing(4, 3, 2),
            // },
            // transition: theme.transitions.create('margin', {
            //     easing: theme.transitions.easing.sharp,
            //     duration: theme.transitions.duration.leavingScreen,
            // }),
            // marginLeft: 0,
        },

        unauthenticatedContent: {
            background: theme.palette.primary.main,
            padding: 0,
            flex: 1,
        },
        snackBar: {
            color: 'white',
        },
        variantSuccess: {
            background: green,
            color: 'white',
        },
        variantError: {
            background: red,
            color: 'white',
        },
        variantInfo: {
            background: indigo,
            color: 'white',
        },
        variantWarning: {
            background: orange,
            color: 'white',
        },
        toolbar: theme.mixins.toolbar,
    };
};

export default styles;
